/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import {
  GREEN_LIGHT,
  PURPLE_FEEK,
  PURPLE_LIGHT,
  PURPLE_MEDIUM,
} from 'styles/colors';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { MEDIA_QUERIES } from 'styles/constants';
import ButtonPrimary from 'components/buttons/ButtonPrimary';
import DinnerInFamily from 'assets/images/DinnerInFamily.png';
import { ReactComponent as CheckCircleOutline } from 'assets/icons/CheckCircleOutline.svg';

const styles = css`
  background-color: #794cc7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    height: auto;
  }

  .content {
    min-width: 600px;
    padding: 40px 72px;
  }

  .mt-16 {
    margin-top: 16px;
  }

  .mb-48 {
    margin-bottom: 48px;
  }

  .items-list-container {
    display: flex;
    flex-direction: row;
    gap: 32px;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }

  .itemlist {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 4px;
  }

  ${MEDIA_QUERIES.smallScreen} {
    flex-direction: column;

    img {
      width: 100%;
    }
  }
`;

const DataToRegister = () => {
  return (
    <div css={styles} id="requirements">
      <div className="content">
        <Text color={PURPLE_LIGHT} fontSize={48} fontWeight={600}>
          ¡Hagámoslo Posible!
        </Text>
        <Text
          fontSize={26}
          fontWeight={300}
          className="mb-48 mt-16"
          color={PURPLE_LIGHT}
        >
          Solo necesitamos los siguientes datos:
        </Text>

        <div className="items-list-container">
          <div>
            <ItemList title="Nombre de negocio" />
            <ItemList title="Usuario de instagram" />
            <ItemList title="Teléfono" />
          </div>
          <div>
            <ItemList title="Email" />
            <ItemList title="Dirección" />
            <ItemList title="Horario de servicio" />
          </div>
        </div>
        <ButtonPrimary
          label="Registrarme"
          pillShape
          width={200}
          color={GREEN_LIGHT}
          textColor={PURPLE_FEEK}
        />
      </div>
      <img src={DinnerInFamily} />
    </div>
  );
};

const ItemList = ({ title }) => {
  return (
    <div className="itemlist">
      <Icon icon={CheckCircleOutline} color={PURPLE_MEDIUM} />
      <Text color={PURPLE_MEDIUM} fontSize={18}>
        {title}
      </Text>
    </div>
  );
};

ItemList.propTypes = {
  title: PropTypes.string.isRequired,
};

export default DataToRegister;
